(function(){
  'use strict';
  var installEvent=null;
  var attempted=false;
  var bound=false;

  function standalone(){
    return (window.matchMedia&&window.matchMedia('(display-mode: standalone)').matches)||navigator.standalone===true;
  }

  function removeLegacyInstallUi(){
    document.querySelectorAll('.lmp-test-install').forEach(function(el){el.remove();});
  }

  function cleanupGestures(){
    if(!bound)return;
    bound=false;
    document.removeEventListener('pointerup',onGesture,true);
    document.removeEventListener('click',onGesture,true);
    document.removeEventListener('touchend',onGesture,true);
  }

  function bindGestures(){
    if(bound||attempted||standalone())return;
    bound=true;
    document.addEventListener('pointerup',onGesture,true);
    document.addEventListener('click',onGesture,true);
    document.addEventListener('touchend',onGesture,true);
  }

  function tryNativeInstall(){
    if(attempted||standalone()||!installEvent)return;
    attempted=true;
    cleanupGestures();
    var ev=installEvent;
    installEvent=null;
    try{
      ev.prompt();
      if(ev.userChoice){
        ev.userChoice.then(function(result){
          if(!result||result.outcome!=='accepted'){
            try{sessionStorage.setItem('lmp_install_dismissed','1');}catch(e){}
          }
        }).catch(function(){});
      }
    }catch(err){
      attempted=false;
      installEvent=ev;
      bindGestures();
    }
  }

  function onGesture(){
    if(!installEvent||attempted||standalone())return;
    tryNativeInstall();
  }

  window.addEventListener('beforeinstallprompt',function(e){
    e.preventDefault();
    if(standalone())return;
    installEvent=e;
    removeLegacyInstallUi();
    bindGestures();
  });

  window.addEventListener('appinstalled',function(){
    attempted=true;
    installEvent=null;
    cleanupGestures();
    removeLegacyInstallUi();
  });

  function init(){
    removeLegacyInstallUi();
    if(!standalone())bindGestures();
    if(window.MutationObserver&&document.documentElement){
      new MutationObserver(function(records){
        records.forEach(function(record){
          record.addedNodes.forEach(function(node){
            if(node.nodeType!==1)return;
            if(node.matches&&node.matches('.lmp-test-install')){node.remove();return;}
            if(node.querySelectorAll){node.querySelectorAll('.lmp-test-install').forEach(function(el){el.remove();});}
          });
        });
      }).observe(document.documentElement,{childList:true,subtree:true});
    }
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();
